export default __webpack_public_path__ + "static/media/1920.76cb4272.png";